import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { FAQTitle } from "../../../Constants/Constants";
import FaqWidgets from "./FaqWidgets";
import FeaturedTutorials from "./FeaturedTutorials";
import LatestArticlesVideos from "./LatestArticlesVideos";
import QuickQuestions from "./QuickQuestions";
import { LatestArticlesVideosFaq } from "../../../Data/Miscellaneous/FAQ";

const FaqContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={FAQTitle} parent={FAQTitle} />
      <Container fluid>
        <div className="faq-wrap">
          <Row>
            <FaqWidgets />
            <QuickQuestions />
            <FeaturedTutorials />
            <LatestArticlesVideos rowClass="latest-articles" data={LatestArticlesVideosFaq} />
          </Row>
        </div>
      </Container>
    </>
  );
};
export default FaqContainer;
